import React from 'react'
import Layout from './Layout'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../features/authSlice";
import RiwayatJabatanList from '../components/RiwayatJabatanList';
import { useEffect } from 'react';


const RiwayatJabatan = () => {
    const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
  }, [isError, navigate]);
  return (
    <Layout>
      <RiwayatJabatanList/>
    </Layout>
  )
}

export default RiwayatJabatan